import { Component, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageConstants } from 'src/app/core/constants/message';
import { IItemDropdown } from 'src/app/core/interfaces/dropdown.models';
import { TipoItemDialogService } from './tipo-item-dialog.service';
import {IRequest} from "./tipo-item-dialog.model";
import {TextValidatorService} from "../../../core/validators/text-validator.service";
import { Table } from 'primeng/table';

@Component({ standalone: false,
  selector: 'app-tipo-item-dialog',
  templateUrl: './tipo-item-dialog.component.html',

  styleUrls: ['./tipo-item-dialog.component.css']
})
export class TipoItemDialogComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);

  @ViewChild('table') table: Table;

  isFirstLoad: boolean = true;
  totalRows: number = 0;
  currentPage: number = 1;
  lsData: IRequest[] = [];
  codigosMessage: any;
  mensajesMessage: any;

  loaded: boolean = true;

  constructor(private personaDialogService: TipoItemDialogService
    , public ref: DynamicDialogRef
    , public config: DynamicDialogConfig
    , private readonly textValidatorService: TextValidatorService){
  }

  ngOnInit(): void {
    let dataReq: IRequest = {
      Codigo:null,
      Nombre:null,
      Activo: true
    };
    this.getData(dataReq, false);
  }

  getData(request: IRequest, pagination: boolean){
    this.loaded = false;
    setTimeout(() => { this.cdr?.detectChanges(); });
    [this.codigosMessage, this.mensajesMessage] = MessageConstants;
    this.personaDialogService.getPaginated(request)
      .subscribe(
        {
          next: (data) => {
            let dataTmp = data;
            if(dataTmp) {
              this.lsData = dataTmp;
              if(pagination){
                setTimeout(() => { this.navigateToPage(this.currentPage); });
              }
            }
            setTimeout(() => { this.cdr?.detectChanges(); });
          },
          error: (error) => {
            if(error){
              console.log(error);
            }
            this.loaded = true;
            setTimeout(() => { this.cdr?.detectChanges(); });
          },
          complete: () => {
            this.loaded = true;
            setTimeout(() => { this.cdr?.detectChanges(); });
          }
        }
      );
  }

  navigateToPage(pageNumber: number) {
    const desiredPageIndex = pageNumber * this.table.rows;
    const first = desiredPageIndex -  this.table.rows;

    if(this.table.totalRecords == first){
      this.table.first = first - this.table.rows;
    }else{
      this.table.first = first;
    }
  }

  onRowDblClick(event: any, dataSelected: any){
    if(dataSelected){
      let _description = ((dataSelected.Codigo) ? dataSelected.Codigo : "" ) + " - " + ((dataSelected.Nombre) ? dataSelected.Nombre: "") ;
      let itemDropdown: IItemDropdown = {
        code: dataSelected.Id,
        description: _description,
        dataSerialize: JSON.stringify(dataSelected)
      }
      this.ref.close(itemDropdown);
    }

  }

  onKeyDownLetters = (event: any) => this.textValidatorService.validateOnlyLetters(event);
  onKeyDownLettersAndNumbers = (event: any) => this.textValidatorService.validateOnlyLettersAndNumbers(event);
}

